import React, { useRef, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AsideContent from './AsideContent';
import { getStoreStockBalance } from '../Actions/StockBalanceAside.action'
import { translate } from '../Services/translation';

const StoreStockBalanceAside = () => {
    const { result } = useSelector((state) => state.storeStockBalance);
    const { product } = useSelector((state) => state.currentProduct);
    const storeRef = useRef({});
    const asideRef = useRef();
    const dispatch = useDispatch();

    const showStockBalance = () => {
        asideRef.current.toggleAside();
        asideRef.current.loading(true);
        dispatch(getStoreStockBalance(product.variantSystemId)).then(i => {
            asideRef.current.loading(false);
        });
    };

    const toggleShowMoreInfo = (store) => {
        storeRef.current[store].classList.toggle('stock-balance-aside__store--show');
    }

    return (
        <Fragment>
            <button className="product-detail__show-aside" onClick={() => showStockBalance()}>
                <img src="/ui/images/marker-black.svg" />
                <span>{translate('code.product.stores.inventory.button.title')}</span>
            </button>
            <AsideContent ref={asideRef} title={translate('code.product.stores.inventory.aside.title')} cssClass="stock-balance">
                <div className="stock-balance-aside">
                    <div className="stock-balance-aside__info-wrapper">
                        <figure className="stock-balance-aside__image-container">
                            <img src={product.imageUrl} />
                        </figure>
                        <article className="stock-balance-aside__info">
                            <div className="stock-balance-aside__info-title">
                                {product.variantName}
                            </div>
                            <div className="stock-balance-aside__info-price">
                                {product.campaignPrice ?
                                    <Fragment>
                                        <span className="stock-balance-aside__info-price--campaign">
                                            {product.campaignPrice}
                                        </span>
                                        <span className="stock-balance-aside__info-price--old">
                                            ({product.price})
                                        </span>
                                    </Fragment>
                                    :
                                    <span className="stock-balance-aside__info-price--price">
                                        {product.price}
                                    </span>
                                }
                            </div>
                            <div className="stock-balance-aside__info-articlenumber">
                                <span>{translate('code.product.stores.inventory.aside.articlenumber')}: </span>
                                <span>{product.baseProductId}</span>
                            </div>
                        </article>
                    </div>
                    <div className="stock-balance-aside__stock-info-wrapper">
                        {result && (
                            result.length > 0 ?
                                result.map((store, index) => (
                                    <div ref={(ref) => (storeRef.current[store.name] = ref)} key={`store-${index}`} className="stock-balance-aside__store" onClick={() => toggleShowMoreInfo(store.name)}>
                                        <div className={`stock-balance-aside__stockstatus ${store.stockStatus.stockStatusCssClass}`}>
                                            <span></span>
                                        </div>
                                        <div className="stock-balance-aside__store-expand">
                                        </div>
                                        <div className="stock-balance-aside__store-info">
                                            <div className="stock-balance-aside__store-info-name">{store.name}</div>
                                            <div className={`stock-balance-aside__store-info-stock-description ${store.stockStatus.stockStatusCssClass}`}>
                                                {store.stockStatus.description}
                                            </div>
                                        </div>
                                        <div className={`stock-balance-aside__store-additional-info`}>
                                            {store.address.address1 ?
                                                <div className="stock-balance-aside__store-address">
                                                    <div className="stock-balance-aside__store-address-title">{translate('code.product.stores.inventory.aside.address.title')}: </div>
                                                    <span>{store.address.address1}, </span>
                                                    <span>{store.address.zipCode}, </span>
                                                    <span>{store.address.city}</span>
                                                </div>
                                                :
                                                null
                                            }
                                            {store.openingHours && store.openingHours.length ?
                                                <Fragment>
                                                    <div className="stock-balance-aside__store-opening-hours-title">{translate('code.product.stores.inventory.aside.openinghours.info')}</div>
                                                    <div className="stock-balance-aside__store-opening-hours">
                                                        {store.openingHours.map((item, index) => (
                                                            <div key={`opening-hour-${index}`} className="stock-balance-aside__store-opening-hours-item">
                                                                {item}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Fragment>
                                                :
                                                null
                                            }
                                        </div>
                                    </div>
                                ))
                                :
                                <div className="stock-balance-aside__missing-stores">{translate("code.product.stores.inventory.aside.missing.stores")}</div>
                        )}
                    </div>
                </div>
            </AsideContent>
        </Fragment>
    );
};

export default StoreStockBalanceAside;